/**
 * The verification wall: a full account that has never verified its email
 * sees only "verify your email" (EmailVerificationOverlay), on every page but
 * the few it still needs to reach. Keyed on `verified`, the one-time flag every
 * backend `withFullAccount` gate reads, not on `emailVerified`, which a later
 * email change resets. See docs/adr/0010-verification-wall-is-a-root-overlay.md.
 */

import { isAuthFlowPath } from '@/utils/auth-redirect'

// Besides the auth flow (log out, password recovery, SSO return): the legal
// texts it links to, and the page the confirmation link lands on. Anchored like
// the auth flow's own pattern.
const WALL_EXEMPT_PATH_RE = /^\/(legal|email\/confirm)(\/|$)/

/**
 * @param {String} [path] - a route path, without the query
 * @returns {Boolean} whether a walled user may still see this page
 */
export const isWallExemptPath = path =>
  isAuthFlowPath(path) || (typeof path === 'string' && WALL_EXEMPT_PATH_RE.test(path))

/**
 * @param {Object|null} user - session user (auth/session getter); null when logged out or before /me loaded
 * @param {String} path - current route path
 * @returns {Boolean} whether the verification wall covers this page
 */
export function showsEmailVerificationWall(user, path) {
  if (!user?.isFullAccount || user.isVerifiedAccount) return false
  return !isWallExemptPath(path)
}
